
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26 15.376L16.5445 24.2938C15.3861 25.3862 13.815 26 12.1768 26C10.5386 26 8.96752 25.3862 7.80914 24.2938C6.65077 23.2013 6 21.7195 6 20.1745C6 18.6295 6.65077 17.1477 7.80914 16.0553L17.2647 7.1375C18.0369 6.40917 19.0843 6 20.1765 6C21.2686 6 22.316 6.40917 23.0882 7.1375C23.8605 7.86583 24.2943 8.85365 24.2943 9.88366C24.2943 10.9137 23.8605 11.9015 23.0882 12.6298L13.6224 21.5476C13.2363 21.9118 12.7126 22.1163 12.1665 22.1163C11.6204 22.1163 11.0968 21.9118 10.7106 21.5476C10.3245 21.1834 10.1076 20.6895 10.1076 20.1745C10.1076 19.6595 10.3245 19.1656 10.7106 18.8014L19.4459 10.5726","stroke":"#10001F","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    